import {calculateExpireTime} from 'utilities/helper/expireTime';

const AuctionCard = ({
  title,
  image,
  createdDate,
  proposal,
  soldTime,
  wrapperClassName,
}: IAuctionCardProps) => {
  const {daysRemain, hoursRemain} = calculateExpireTime(soldTime);

  return (
    <>
      <div
        className={`flex bg-white justify-between rounded-lg h-30 mx-2 px-2 py-3 shadow-md w-72 mb-3  ${wrapperClassName}`}
      >
        <div className="relative">
          <span className=" absolute top-2 right-1 text-xs text-created-day bg-white py-1 px-2 rounded-3xl">
            {createdDate}
          </span>
          <img
            className="object-cover  rounded-md flex-none w-[120px] h-[103px]"
            src={image}
            alt={title}
            width={110}
            height={103}
          />
        </div>
        <div>
          <div className="flex flex-col justify-between p-2 h-full">
            <p className=" text-black overflow-hidden max-w-[156px] truncate text-sm font-extrabold text-start">
              {title}
            </p>
            <div>
              <div className=" flex flex-col gap-2 justify-between">
                <div className="flex items-center h-[45%]">
                  <span className="icon-auction-card ml-1 text-sm text-primary"></span>
                  <p className=" text-sm text-gray-6 ">
                    {proposal.toLocaleString()} پیشنهاد
                  </p>
                </div>
                <div className="flex items-center h-[45%]">
                  <span className="icon-clock text-red-1 ml-1 h-full" />
                  <p className="font-normal text-sm text-red-1 h-full items-center flex gap-1">
                    <span>{daysRemain}روز</span>
                    <span>{hoursRemain}ساعت باقی مانده</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AuctionCard;
